import React, { useState, useMemo } from "react";
import {
  FaEdit,
  FaUsers,
  FaClipboardList,
  FaMedkit,
  FaUserShield,
  FaStar,
  FaSearch,
  FaTable,
  FaDiscord,
} from "react-icons/fa";
import PreviewPopup from "./PreviewPopup";

const TripDetailsActions = ({
  onEditClick,
  onRegistrationsClick,
  onAttendanceClick,
  onAccessClick,
  onInsuranceClick,
  onPriorityClick,
  onSummaryClick,
  onDiscordClick,
  onMarkReadyForSettlement,
  tripGuid,
  tripSettlementStatus,
  hasExplicitAccess,
}) => {
  const baseUrl = process.env.REACT_APP_TRIPS_BASE;
  const [previewOpen, setPreviewOpen] = useState(false);

  const previewUrl = useMemo(() => {
    if (!baseUrl || !tripGuid) return "";
    return `${baseUrl}/${tripGuid}`;
  }, [baseUrl, tripGuid]);

  const actions = [
    {
      key: "edit",
      label: "Edytuj",
      icon: <FaEdit className="trip-details-button-icon" />,
      onClick: onEditClick,
      requiresExplicit: true,
    },
    {
      key: "registrations",
      label: "Rejestracje",
      icon: <FaClipboardList className="trip-details-button-icon" />,
      onClick: onRegistrationsClick,
      requiresExplicit: false,
    },
    {
      key: "people",
      label: "Osoby",
      icon: <FaUsers className="trip-details-button-icon" />,
      onClick: onAttendanceClick,
      requiresExplicit: true,
    },
    {
      key: "discord",
      label: "Discord",
      icon: <FaDiscord className="trip-details-button-icon" />,
      onClick: onDiscordClick,
      // zdecyduj:
      // - jeśli Discord też ma być tylko po full => true
      // - jeśli może być bez full => false
      requiresExplicit: true,
    },
    {
      key: "insurance",
      label: "Ubezp. tur.",
      icon: <FaMedkit className="trip-details-button-icon" />,
      onClick: onInsuranceClick,
      requiresExplicit: true,
    },
    {
      key: "access",
      label: "Dostęp",
      icon: <FaUserShield className="trip-details-button-icon" />,
      onClick: onAccessClick,
      requiresExplicit: true,
    },
    {
      key: "preview",
      label: "Podgląd",
      icon: <FaSearch className="trip-details-button-icon" />,
      onClick: () => setPreviewOpen(true),
      requiresExplicit: false,
    },
    {
      key: "priority",
      label: "Zapisy priorytetowe",
      icon: <FaStar className="trip-details-button-icon" />,
      onClick: onPriorityClick,
      requiresExplicit: true,
    },
    ...(tripSettlementStatus === 1
      ? [
          {
            key: "readyForSettlement",
            label: "Zgłoś do rozl.",
            icon: <i className="fa-solid fa-file-circle-check trip-details-button-icon" />,
            onClick: onMarkReadyForSettlement,
            requiresExplicit: true,
          },
        ]
      : []),
    {
      key: "summary",
      label: "Zestawienia",
      icon: <FaTable className="trip-details-button-icon" />,
      onClick: onSummaryClick,
      requiresExplicit: false,
    },
  ];

  const visibleActions = actions.filter(
    (a) => !a.requiresExplicit || hasExplicitAccess
  );

  return (
    <div className="trip-details-buttons">
      {visibleActions.map((a) => (
        <div key={a.key} className="trip-details-button-container" onClick={a.onClick}>
          <div className="trip-details-button">{a.icon}</div>
          <span className="trip-details-button-label">{a.label}</span>
        </div>
      ))}

      {previewOpen && (
        <PreviewPopup
          url={previewUrl}
          title="Podgląd wycieczki"
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </div>
  );
};

export default TripDetailsActions;
